import axios from 'axios';
import { metaCaching } from '../../utils/MetaData';

export const ComparePhotoApi = {
  loadTasks: filter => axios.get(`/api/public/face_rec/all_tasks?filter=${filter}`),
  orderUp: taskId => axios.put(`/api/public/face_rec/${taskId}/order_up`),
  orderDown: taskId => axios.put(`/api/public/face_rec/${taskId}/order_down`),
  createOrder: data => axios.post(`/api/public/face_rec/new_task`, data),
  deleteOrder: taskId => axios.delete(`/api/public/face_rec/${taskId}`),
  loadMeta: metaKey => metaCaching(`/api/public/metadata/${metaKey}`),
  getDDO: filter =>
    axios.get(`/api/public/info/paging/service_provider?filter=${filter}`),
  getResultFromCompletedTask: filter =>
    axios.get(`/api/public/face_rec/result?filter=${filter}`),
  getContingentItem: id => axios.get(`/api/public/passport/contingent/${id}`)
};
